import Sidebar from "./Sidebar";
export default function Layout({ children }) {
  return (
    <div className="redesign-wrapper">
      <Sidebar />
      <div className="rd-content-main">{children}</div>
    </div>
  );
}
